// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d0180eed","866":"2b1bdfb2"}[chunkId] + ".chunk.js";
};